module.exports = __webpack_public_path__ + "static/victory_emoji-480ad4ce6f85d4a04176f7d668bb784c.svg";